import { isRef, ref } from "vue";
/**
 * @description 값이 ref인지 확인하고, ref가 아니라면 ref로 변환합니다.
 * @param value 변환할 값
 */
export const toValue = (value) => {
    return isRef(value)
        ? value
        : ref(value);
};
